import { MenuItem, SelectChangeEvent, TextField } from "@mui/material";
import React from "react";

import { useAuth } from "@/providers";
import { useRoboqlExternalCtx } from "@/Search/SearchBar/MultiSearch/useRoboqlExternalCtx";
import { RoboqlEditor } from "@/shared/components/RoboqlEditor";
import { QueryTarget } from "@/shared/domain/query";

import styles from "./TriggerInvocationInput.module.css";

interface TriggerInvocationInputProps {
  roboqlQuery: string | undefined;
  onRoboqlQueryChanged: (newQuery: string | undefined) => void;
  queryTarget: QueryTarget;
  onQueryTargetChanged: (newTarget: QueryTarget) => void;
}

const QUERY_OPTIONS = [
  {
    label: "File Query",
    value: QueryTarget.Files.toString(),
  },
  {
    label: "Topic Query",
    value: QueryTarget.Topics.toString(),
  },
];

export const TriggerInvocationInput: React.FC<TriggerInvocationInputProps> = ({
  roboqlQuery,
  onRoboqlQueryChanged,
  queryTarget,
  onQueryTargetChanged,
}: TriggerInvocationInputProps) => {
  const { currentOrganization } = useAuth();

  const queryMenuItems = QUERY_OPTIONS.map((option) => {
    return (
      <MenuItem
        key={`query-target-option-${option.value}`}
        value={option.value}
      >
        {option.label}
      </MenuItem>
    );
  });

  const roboqlExternalCtx = useRoboqlExternalCtx(
    queryTarget,
    currentOrganization?.org_id ?? "",
  );

  return (
    <div className={styles.editableContainer}>
      <TextField
        className={styles.queryType}
        label={"Query Type"}
        select
        size="small"
        value={queryTarget.toString()}
        SelectProps={{
          onChange: (event: SelectChangeEvent<unknown>) => {
            onQueryTargetChanged(event.target.value as string as QueryTarget);
          },
        }}
      >
        {queryMenuItems}
      </TextField>

      <RoboqlEditor
        containerBorder={1}
        containerClassName={styles.roboqlContainer}
        editorOptions={{
          padding: {
            // center text; determined through trial and error
            top: 4,
          },
          scrollbar: {
            // show a vertical scrollbar when the query gets long enough
            vertical: "auto",
          },
        }}
        initialValue={roboqlQuery ?? ""}
        onChange={onRoboqlQueryChanged}
        target={queryTarget}
        triggerCompletionOnEmptyInitialValue={false}
        roboqlExternalCtx={roboqlExternalCtx}
      />
    </div>
  );
};
